import type { ReactElement } from 'react';

import { useIsLargeScreen } from '@bestseller-bit/frontend-community.theme.buying-theme';
import Skeleton from '@mui/material/Skeleton';

interface AutocompleteLoadingProps {
    /** Addition to the height in pixels */
    heightAddition?: number;
    /** Exclude label from the height calculation */
    excludeLabel?: boolean;
}

const AutocompleteLoading = ({
    heightAddition = 0,
    excludeLabel = false,
}: AutocompleteLoadingProps): ReactElement => {
    const isLargeScreen = useIsLargeScreen();

    const baseHeight = isLargeScreen ? 56 : 46;
    const labelSize = isLargeScreen ? 16 : 14;
    const labelHeight = excludeLabel ? labelSize : 0;

    const height = baseHeight + heightAddition - labelHeight;

    return (
        <Skeleton
            variant="rectangular"
            height={`${height}px`}
            width="100%"
        />
    );
};

export { AutocompleteLoading };
